var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wlx-basic-info-wrapper"},[(_vm.tabName=='first')?_c('BasicInfo'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }